/**
 * This array contains the codes of emojis that are rendered incorrectly on Windows 10.
 * We hide these emojis in the application to avoid visual issues
 * and ensure a consistent user experience across all platforms.
 */
export const HIDDEN_EMOJIS = [
  '1fae0',
  '1f972',
  '1fae2',
  '1fae3',
  '1fae1',
  '1fae5',
  '1f978',
  '1fae4',
  '1f979',
  '1faf1',
  '1faf2',
  '1faf3',
  '1faf4',
  '1f90c',
  '1faf0',
  '1faf5',
  '1faf6',
  '1fac0',
  '1fac1',
  '1fae6',
  '1f977',
  '1fac5',
  '1fac3',
  '1fac4',
  '1f9cc',
  '1fac2',
  '1f9ac',
  '1f9a3',
  '1f9ab',
  '1f9a4',
  '1fab6',
  '1f9ad',
  '1fab8',
  '1fab2',
  '1fab3',
  '1fab0',
  '1fab1',
  '1fab7',
  '1fab4',
  '1fab9',
  '1faba',
  '1fad0',
  '1fad2',
  '1fad1',
  '1fad8',
  '1fad3',
  '1fad4',
  '1fad5',
  '1fad6',
  '1fad7',
  '1f9cb',
  '1fad9',
  '1faa8',
  '1fab5',
  '1f6d6',
  '1f6dd',
  '1f6fc',
  '1f6de',
  '1f6df',
  '1fa84',
  '1faac',
  '1fa85',
  '1faa9',
  '1fa86',
  '1faa1',
  '1faa2',
  '1fa74',
  '1fa96',
  '1fa97',
  '1fa98',
  '1faab',
  '1fa99',
  '1fa83',
  '1fa9a',
  '1fa9b',
  '1fa9d',
  '1fa9c',
  '1fa7c',
  '1fa7b',
  '1f6d7',
  '1fa9e',
  '1fa9f',
  '1faa0',
  '1faa4',
  '1faa3',
  '1fae7',
  '1faa5',
  '1faa6',
  '1faa7',
  '1faaa',
  '1f7f0',
  '1f6fb',
];
